import Select from "react-select";
import {Field} from "../../../../ui/Field";
import React from "react";

export const CustomerClient = ({errors,name,setName,city,cityFilter,setCity,entities,entity,setEntity,note,setNote,code, setCode}) => (<>
    <div className="form-group mb-3">
        <label
            htmlFor="exampleInputEmail1"
            className="form-label"
        >
            Hd entity{' '}
            <span style={{ color: 'red' }}>*</span>
        </label>
        <Select
            onChange={(e) => {
                setEntity(e);
                setCity(null);
            }}
            options={entities}
            value={entity}
            isSearchable
            isClearable
            className={
                errors['HDEntity']
                    ? ' is-invalid'
                    : ''
            }
        />
        {errors['HDEntity'] && (
            <div className="invalid-feedback">
                {errors['HDEntity']}
            </div>
        )}
    </div>

    <div className="form-group mb-3">
        <label
            htmlFor="exampleInputEmail1"
            className="form-label"
        >
            City{' '}
            <span style={{ color: 'red' }}>*</span>
        </label>
        <Select
            required
            onChange={(e) => setCity(e)}
            options={cityFilter}
            value={city}
            isSearchable
            isClearable
            className={
                errors['city'] ? ' is-invalid' : ''
            }
        />
        {errors['city'] && (
            <div className="invalid-feedback">
                {errors['city']}
            </div>
        )}
    </div>

    <Field
        name="name"
        error={errors['name']}
        className="mb-3"
        required
        value={name}
        onChange={(e) => setName(e.target.value)}
    >
        Client name
    </Field>

    <Field
        name="code_2"
        error={errors['code_2']}
        className="mb-3"
        required
        value={code || name
            .replace(/\s/g, '')
            .slice(0, 5)}
        onChange={(e) => setCode(e.target.value)}
    >
        Client code 2
    </Field>

    <Field
        name="description"
        error={errors['description']}
        className="mb-3"
        type="textarea"
        value={note}
        onChange={(e) => setNote(e.target.value)}
    >
        Note
    </Field>

</>)
